import React from 'react';
import Joyride, { Props } from 'react-joyride';

import SZJoyrideTooltip from '@buyside/components/presentation/Joyride/szJoyrideTooltip';

import styles from './szJoyrideStyles.scss';

const SZJoyride: React.FC<Props> = props => (
  <Joyride
    {...props}
    styles={{
      options: {
        primaryColor: styles?.blueColor,
        zIndex: 700
      }
    }}
    scrollOffset={65 + 15} // (top navigation height + some padding)
    tooltipComponent={SZJoyrideTooltip}
  />
);

export default SZJoyride;
